function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0003 14.759C16.0246 14.759 16.0479 14.7492 16.0649 14.7319C16.082 14.7146 16.0914 14.6912 16.091 14.6669C16.091 14.6296 16.0684 14.5959 16.0339 14.5818C15.9993 14.5676 15.9596 14.5757 15.9334 14.6023C15.9072 14.6289 15.8997 14.6687 15.9143 14.7031C15.929 14.7374 15.963 14.7595 16.0003 14.759",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.3293 7.03126V7.03126C27.3764 11.0787 27.3764 17.6406 23.3293 21.688V21.688L17.727 27.2904C16.7733 28.2438 15.2273 28.2438 14.2735 27.2904L8.67122 21.688C6.72706 19.7447 5.63477 17.1085 5.63477 14.3596C5.63477 11.6108 6.72706 8.97457 8.67122 7.03126V7.03126C10.6146 5.08669 13.2511 3.99414 16.0003 3.99414C18.7495 3.99414 21.386 5.08669 23.3293 7.03126Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5068 14.759C11.544 14.759 11.5776 14.7366 11.5918 14.7022C11.6061 14.6678 11.5982 14.6282 11.5719 14.6019C11.5455 14.5755 11.506 14.5677 11.4716 14.5819C11.4372 14.5962 11.4147 14.6297 11.4147 14.6669C11.4147 14.6914 11.4244 14.7148 11.4417 14.732C11.459 14.7493 11.4824 14.759 11.5068 14.759",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4944 14.759C20.5187 14.759 20.542 14.7492 20.5591 14.7319C20.5761 14.7146 20.5855 14.6912 20.5852 14.6669C20.5851 14.6296 20.5626 14.5959 20.528 14.5818C20.4935 14.5676 20.4538 14.5757 20.4276 14.6023C20.4013 14.6289 20.3938 14.6687 20.4085 14.7031C20.4231 14.7374 20.4571 14.7595 20.4944 14.759",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLocationPin = function SvgLocationPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-pin.b0b82cfb.svg";
export { ForwardRef as ReactComponent };